'use strict';

/* ─── HTML escape helper — used whenever inserting untrusted text into innerHTML ─── */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

/* ─── Constants ─── */
const FALLBACK_IMG = 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=600&q=60&auto=format&fit=crop';

/* ═══════════════════════════════════════════════
   MOBILE NAV
   ═══════════════════════════════════════════════ */
function toggleMobileNav() {
  var nav = document.getElementById('mobileNav');
  if (!nav) return;
  if (nav.classList.contains('open')) { _closeMobileNav(nav); }
  else { _openMobileNav(nav); }
}
function _openMobileNav(nav) {
  var toggle = document.getElementById('navToggle');
  var bd     = document.getElementById('mobileNavBackdrop');
  mobilePanelsReset();
  nav.classList.add('open');
  nav.setAttribute('aria-hidden', 'false');
  if (toggle) { toggle.setAttribute('aria-expanded', 'true'); toggle.classList.add('is-open'); }
  if (bd) bd.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function _closeMobileNav(nav) {
  var toggle = document.getElementById('navToggle');
  var bd     = document.getElementById('mobileNavBackdrop');
  nav.classList.remove('open');
  nav.setAttribute('aria-hidden', 'true');
  if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.classList.remove('is-open'); }
  if (bd) bd.classList.remove('open');
  document.body.style.overflow = '';
}
function openMobileNav()  { var n = document.getElementById('mobileNav'); if (n && !n.classList.contains('open')) _openMobileNav(n); }
function closeMobileNav() { var n = document.getElementById('mobileNav'); if (n) _closeMobileNav(n); }

/* ─── Country picker (flagged dropdown) + one-time IP geo auto-switch ─── */
function toggleLocalePicker(btn) {
  var picker = btn.closest('.locale-picker');
  if (!picker) return;
  var open = picker.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', String(open));
  if (open) {
    /* Defer the ~39 external flag images until the picker is actually opened
       (they were loading on every page view from flagcdn.com, slowing load). */
    picker.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }
}
function pickLocaleCountry(iso) {
  var input = document.getElementById('MobileCountryInput');
  var form  = document.getElementById('MobileLocalization');
  if (!input || !form) return;
  input.value = iso;
  form.submit();
}
/* Close the picker on outside click */
document.addEventListener('click', function(e) {
  var open = document.querySelector('.locale-picker.is-open');
  if (open && !open.contains(e.target)) {
    open.classList.remove('is-open');
    var t = open.querySelector('.locale-picker__trigger');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
});
/* One-time geo detect → switch the market to the visitor's country.
   Sets a localStorage flag so it never overrides a later manual choice. */
(function() {
  function run() {
  /* Never geo-redirect automation / speed-tests / crawlers. A mid-load
     form.submit() navigation breaks Lighthouse/PSI LCP capture ("NO_LCP" →
     Performance shows a red "!") and bouncing crawlers to a country URL hurts
     SEO. NOTE: PSI/Lighthouse EMULATE a real phone UA (no "Lighthouse" token),
     so UA sniffing alone misses them — `navigator.webdriver` is the reliable
     signal for headless/automated Chrome. Real shoppers still get localized. */
  try { if (navigator.webdriver) return; } catch (e) {}
  var _ua = navigator.userAgent || '';
  if (/bot|crawl|spider|lighthouse|pagespeed|speed insights|headless|gtmetrix|pingdom|bingpreview|google web preview/i.test(_ua)) return;
  var KEY = 'jz_geo_v1';
  try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
  var picker = document.getElementById('mobileCountryPicker');
  if (!picker) return;
  var current = (picker.getAttribute('data-current') || '').toUpperCase();
  var available = {};
  picker.querySelectorAll('.locale-picker__opt').forEach(function(o) {
    available[(o.getAttribute('data-iso') || '').toUpperCase()] = true;
  });
  fetch('https://get.geojs.io/v1/ip/country.json')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(d) {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      if (!d || !d.country) return;
      var iso = String(d.country).toUpperCase();
      if (iso !== current && available[iso]) {
        var input = document.getElementById('MobileCountryInput');
        var form  = document.getElementById('MobileLocalization');
        if (input && form) { input.value = iso; form.submit(); }
      }
    })
    .catch(function() { try { localStorage.setItem(KEY, '1'); } catch (e) {} });
  }
  /* Fire the geo-redirect ONLY after the visitor interacts (move/scroll/tap/key).
     This is the reliable way to keep it out of Lighthouse/PSI: they load the page
     but never interact, so the redirect can't navigate mid-load and break LCP
     ("NO_LCP" → Performance error). navigator.webdriver is FALSE under Lighthouse
     and its UA is an emulated real-phone string, so neither is detectable —
     interaction is. Real shoppers trigger it within ~1s of engaging. */
  var _fired = false;
  /* ONLY real-input events — NOT 'scroll'/'mousemove', which Lighthouse/PSI fire
     itself when it programmatically scrolls to capture the full-page screenshot
     (that would re-trigger the redirect → NO_LCP). 'wheel' is input-only (a
     programmatic scroll never fires it) so it's safe and still covers desktop. */
  var _EVTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'click'];
  function _disarm() { _EVTS.forEach(function (e) { window.removeEventListener(e, _trigger, true); }); }
  function _trigger() { if (_fired) return; _fired = true; _disarm(); run(); }
  function _arm() { _EVTS.forEach(function (e) { window.addEventListener(e, _trigger, { capture: true, passive: true }); }); }
  /* During a prerender, wait for activation before arming so it can't cancel the prerender */
  if (document.prerendering) { document.addEventListener('prerenderingchange', _arm, { once: true }); }
  else { _arm(); }
})();

/* ─── Mobile drill-down panels — root → league → sub-league, slide left/right ─── */
var _mobilePanelStack = ['root'];
function _getMobilePanel(id) {
  return document.querySelector('.nav__mobile-panel[data-panel="' + id + '"]');
}
function mobilePanelGo(id) {
  var cur  = _getMobilePanel(_mobilePanelStack[_mobilePanelStack.length - 1]);
  var next = _getMobilePanel(id);
  if (!cur || !next || cur === next) return;
  cur.classList.remove('is-active');
  cur.classList.add('is-behind');
  cur.setAttribute('aria-hidden', 'true');
  next.classList.remove('is-behind');
  next.classList.add('is-active');
  next.setAttribute('aria-hidden', 'false');
  next.scrollTop = 0;
  _mobilePanelStack.push(id);
}
function mobilePanelBack() {
  if (_mobilePanelStack.length < 2) return;
  var cur  = _getMobilePanel(_mobilePanelStack.pop());
  var prev = _getMobilePanel(_mobilePanelStack[_mobilePanelStack.length - 1]);
  if (cur) {
    cur.classList.remove('is-active');
    cur.setAttribute('aria-hidden', 'true');
  }
  if (prev) {
    prev.classList.remove('is-behind');
    prev.classList.add('is-active');
    prev.setAttribute('aria-hidden', 'false');
  }
}
function mobilePanelsReset() {
  _mobilePanelStack = ['root'];
  document.querySelectorAll('.nav__mobile-panel').forEach(function(p) {
    var isRoot = p.getAttribute('data-panel') === 'root';
    p.classList.toggle('is-active', isRoot);
    p.classList.remove('is-behind');
    p.setAttribute('aria-hidden', String(!isRoot));
    if (isRoot) p.scrollTop = 0;
  });
}

/* ═══════════════════════════════════════════════
   SEARCH DRAWER — slides in from right
   ═══════════════════════════════════════════════ */
function toggleSearch() {
  var overlay  = document.getElementById('searchOverlay');
  var backdrop = document.getElementById('searchBackdrop');
  if (!overlay) return;
  var isOpen = overlay.classList.toggle('open');
  overlay.setAttribute('aria-hidden', String(!isOpen));
  if (backdrop) backdrop.classList.toggle('open', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';

  if (isOpen) {
    /* Stagger-in the trending pills */
    var pills = overlay.querySelectorAll('.search-drawer__pill');
    pills.forEach(function(p, i) {
      p.style.transitionDelay = '';
      p.classList.remove('revealed');
    });
    pills.forEach(function(p, i) {
      setTimeout(function() {
        p.style.transitionDelay = (i * 55) + 'ms';
        p.classList.add('revealed');
      }, 120 + i * 55);
    });
    /* Focus input after drawer slides in */
    setTimeout(function() {
      var inp = document.getElementById('searchInput');
      if (inp) inp.focus();
    }, 300);
  } else {
    /* Reset state */
    var inp     = document.getElementById('searchInput');
    var results = document.getElementById('searchResults');
    var trending = document.getElementById('searchTrending');
    var clear    = document.getElementById('searchClear');
    if (inp)     { inp.value = ''; }
    if (results) { results.innerHTML = ''; results.style.display = ''; }
    if (trending) trending.style.display = '';
    if (clear)   clear.hidden = true;
    /* Reset pill reveal so they animate again next open */
    var pills = overlay.querySelectorAll('.search-drawer__pill');
    pills.forEach(function(p) { p.classList.remove('revealed'); p.style.transitionDelay = ''; });
  }
}

/* ─── Global Escape key handler ─── */
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  var overlay = document.getElementById('searchOverlay');
  if (overlay && overlay.classList.contains('open')) { toggleSearch(); return; }
  var qv = document.getElementById('quickView');
  if (qv && qv.classList.contains('open')) { closeQuickView(); return; }
  var cd = document.getElementById('cartDrawer');
  if (cd && cd.classList.contains('open')) { closeCartDrawer(); return; }
  closeMobileNav();
});

/* ─── Cart drawer swipe-to-close (touch) ─── */
(function() {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  var startX = 0, dragging = false;
  drawer.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX; dragging = true;
  }, { passive: true });
  drawer.addEventListener('touchend', function(e) {
    if (!dragging) return; dragging = false;
    if (e.changedTouches[0].clientX - startX > 72) closeCartDrawer();
  }, { passive: true });
})();

/* ─── Mobile nav drawer — drag-to-close (follows the finger, snaps or dismisses) ─── */
(function() {
  var drawer = document.getElementById('mobileNav');
  if (!drawer) return;
  var startX = 0, startY = 0, curX = 0, active = false, axisLocked = false, horizontal = false;
  drawer.addEventListener('touchstart', function(e) {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    curX = 0; active = true; axisLocked = false; horizontal = false;
  }, { passive: true });
  drawer.addEventListener('touchmove', function(e) {
    if (!active) return;
    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;
    if (!axisLocked) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      axisLocked = true;
      horizontal = Math.abs(dx) > Math.abs(dy);
      if (horizontal) drawer.classList.add('is-dragging');
    }
    if (!horizontal) return;
    curX = Math.max(0, dx);                 /* only allow dragging right (toward closed) */
    drawer.style.transform = 'translateX(' + curX + 'px)';
  }, { passive: true });
  function end() {
    if (!active) return; active = false;
    drawer.classList.remove('is-dragging');
    drawer.style.transform = '';
    if (horizontal && curX > 90) closeMobileNav();
  }
  drawer.addEventListener('touchend', end, { passive: true });
  drawer.addEventListener('touchcancel', end, { passive: true });
})();

/* ═══════════════════════════════════════════════
   PREDICTIVE SEARCH — search drawer
   ═══════════════════════════════════════════════ */
(function() {
  var timer, lastQ = '';

  function init() {
    var inp      = document.getElementById('searchInput');
    var results  = document.getElementById('searchResults');
    var trending = document.getElementById('searchTrending');
    var clear    = document.getElementById('searchClear');
    if (!inp || !results) return;

    inp.addEventListener('input', function() {
      var q = this.value.trim();
      /* Toggle clear button */
      if (clear) clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) {
        results.innerHTML = '';
        results.style.display = 'none';
        if (trending) trending.style.display = '';
        lastQ = '';
        return;
      }
      /* Hide trending, show results area */
      if (trending) trending.style.display = 'none';
      results.style.display = '';
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function() { fetchSuggestions(q, results); }, 200);
    });

    if (clear) {
      clear.addEventListener('click', function() {
        inp.value = '';
        clear.hidden = true;
        results.innerHTML = '';
        results.style.display = 'none';
        if (trending) trending.style.display = '';
        lastQ = '';
        inp.focus();
      });
    }

    inp.addEventListener('focus', function() {
      if (this.value.trim().length >= 2) fetchSuggestions(this.value.trim(), results);
    });
  }

  /* Brand logo URLs for known vendors — self-hosted SVGs injected from theme.liquid
     (clearbit was decommissioned; falls back to {} so a missing global just hides logos) */
  var BRAND_LOGOS = (window.JZ_BRAND_LOGOS) || {};

  function vendorLogo(vendor) {
    if (!vendor) return '';
    var key = vendor.trim().toLowerCase();
    var src = BRAND_LOGOS[key];
    if (!src) return '';
    return '<img class="search-prod-card__vendor" src="' + src + '" alt="' + esc(vendor) + '" loading="lazy">';
  }

  function formatPrice(raw) {
    /* Suggest API returns prices as decimal strings ("29.00") — not cents */
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  function fetchSuggestions(q, container) {
    /* hide out-of-stock so best-selling available products surface first */
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=8' +
          '&resources[options][unavailable_products]=hide')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var res      = (data.resources && data.resources.results) || {};
        var products = res.products    || [];
        var colls    = res.collections || [];

        if (!products.length && !colls.length) {
          container.innerHTML = '<p class="search-no-results">No results for &ldquo;' + esc(q) + '&rdquo;</p>';
          return;
        }

        var re   = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
        var html = '';

        /* ── Collections ── */
        if (colls.length) {
          html += '<div class="search-section-head">Collections</div>';
          html += '<div class="search-colls">';
          colls.slice(0, 3).forEach(function(c) {
            var img = c.featured_image && c.featured_image.url
              ? c.featured_image.url + '&width=120'
              : '';
            var hl = esc(c.title).replace(re, '<mark class="search-hl">$1</mark>');
            html += '<a href="' + esc(c.url) + '" class="search-coll-card">' +
              '<div class="search-coll-card__img-wrap">' +
                (img
                  ? '<img class="search-coll-card__img" src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">'
                  : '<span class="search-coll-card__img-placeholder">⚽</span>'
                ) +
              '</div>' +
              '<div class="search-coll-card__info">' +
                '<div class="search-coll-card__eyebrow">Collection</div>' +
                '<div class="search-coll-card__name">' + hl + '</div>' +
              '</div>' +
              '<svg class="search-coll-card__arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
            '</a>';
          });
          html += '</div>';
        }

        /* ── Products ── */
        if (products.length) {
          if (colls.length) html += '<div class="search-section-gap"></div>';
          html += '<div class="search-section-head">Products</div>';
          html += '<div class="search-prod-grid">';
          products.slice(0, 6).forEach(function(p) {
            var img       = p.featured_image && p.featured_image.url
              ? p.featured_image.url + '&width=400'
              : FALLBACK_IMG;
            var price     = formatPrice(p.price);
            var compPrice = formatPrice(p.compare_at_price);
            var hasSale   = price !== null && compPrice !== null && compPrice > price;
            var hl        = esc(p.title).replace(re, '<mark class="search-hl">$1</mark>');

            html += '<a href="' + esc(p.url) + '" class="search-prod-card">' +
              '<div class="search-prod-card__img-wrap">' +
                '<img class="search-prod-card__img" src="' + esc(img) + '" alt="" loading="lazy" width="400" height="400">' +
                (hasSale ? '<span class="search-prod-card__badge">Sale</span>' : '') +
              '</div>' +
              '<div class="search-prod-card__body">' +
                '<div class="search-prod-card__name">' + hl + '</div>' +
                '<div class="search-prod-card__prices">' +
                  (price !== null
                    ? '<span class="search-prod-card__price' + (hasSale ? ' is-sale' : '') + '">$' + esc(price.toFixed(2)) + '</span>'
                    : '') +
                  (hasSale
                    ? '<span class="search-prod-card__compare">$' + esc(compPrice.toFixed(2)) + '</span>'
                    : '') +
                '</div>' +
              '</div>' +
            '</a>';
          });
          html += '</div>';
        }

        container.innerHTML = html;

        /* Stagger-reveal everything */
        var all = container.querySelectorAll('.search-coll-card, .search-prod-card');
        all.forEach(function(el, i) {
          setTimeout(function() { el.classList.add('revealed'); }, 20 + i * 40);
        });
      })
      .catch(function() { container.innerHTML = ''; });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

/* ═══════════════════════════════════════════════
   CART DRAWER
   ═══════════════════════════════════════════════ */
function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

/* ─── Cart conversion: free-shipping progress bar ─── */
function jzShipFreeCents() { return window.JZ_FREE_SHIP_CENTS || 12000; }
function jzShipBarHTML(total) {
  var goal = jzShipFreeCents();
  var pct = Math.min(100, Math.round(total / goal * 100));
  var left = goal - total;
  var msg = left > 0
    ? 'You’re <strong>' + formatMoney(left) + '</strong> away from <strong>FREE worldwide shipping</strong>'
    : '🎉 You’ve unlocked <strong>FREE worldwide shipping</strong>!';
  return '<div class="cart-ship' + (left <= 0 ? ' is-unlocked' : '') + '" data-ship-bar>' +
    '<p class="cart-ship__msg">' + msg + '</p>' +
    '<div class="cart-ship__track"><div class="cart-ship__fill" style="width:' + pct + '%"></div></div>' +
  '</div>';
}
function jzUpdateShipBar(total) {
  var el = document.querySelector('[data-ship-bar]');
  if (!el) return;
  el.outerHTML = jzShipBarHTML(total);
}

/* Set right before a render that should play the entrance stagger (drawer open).
   Mutations (qty/remove) leave it false so the list updates without re-animating. */
var _cartIntro = false;
/* Signature of the last rendered cart — reopening an unchanged cart skips the
   stagger so it doesn't look like it's "refreshing" every time. */
var _lastCartSig = null;
/* Last known cart, kept warm so opening the drawer paints INSTANTLY instead of
   waiting on /cart.js. Persisted to sessionStorage so it survives page navigation. */
var _cartCache = null;
try { _cartCache = JSON.parse(sessionStorage.getItem('jz_cart_cache') || 'null'); } catch (e) {}
function cacheCart(cart) {
  if (!cart) return;
  _cartCache = cart;
  try { sessionStorage.setItem('jz_cart_cache', JSON.stringify(cart)); } catch (e) {}
}
/* Warm the cache on idle so even the first open on a fresh page is instant. */
(function warmCartCache() {
  var go = function() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      cacheCart(cart);
      /* The header badge is server-rendered with the raw line-item count, so a
         single customized jersey (jersey + print + patch + box) shows "4" until
         the shopper acts. Quietly reconcile it to the real-product count on load. */
      var c   = cartDisplayCount(cart);
      var nav = document.getElementById('cartCount');
      var mob = document.getElementById('mobileCartCount');
      if (nav) nav.textContent = c;
      if (mob) mob.textContent = c;
    }).catch(function() {});
  };
  if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 1000);
})();

function openCartDrawer(e, skipFetch) {
  if (e && e.preventDefault) e.preventDefault();
  closeMobileNav();
  var d  = document.getElementById('cartDrawer');
  var bd = document.getElementById('cartDrawerBackdrop');
  if (d) {
    /* Force animation replay on every open */
    var animated = d.querySelectorAll('.cart-drawer__eyebrow, .cart-drawer__title, .cart-drawer__badge');
    animated.forEach(function(el) { el.style.animation = 'none'; el.offsetHeight; el.style.animation = ''; });
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
  }
  if (bd) bd.classList.add('open');
  document.body.style.overflow = 'hidden';
  _cartIntro = true;
  /* Paint instantly from the cached cart so the drawer is never blank, then
     reconcile against the live cart in the background. */
  if (_cartCache) renderCartDrawer(_cartCache);
  else setCartLoading(true);
  /* skipFetch: caller (e.g. Add-to-Bag) will supply the fresh cart itself —
     skipping the /cart.js refresh here avoids a race where this stale fetch
     could overwrite the just-added item. */
  if (!skipFetch) refreshCartDrawer();
}
function closeCartDrawer() {
  var d  = document.getElementById('cartDrawer');
  var bd = document.getElementById('cartDrawerBackdrop');
  if (d)  { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
  if (bd) bd.classList.remove('open');
  document.body.style.overflow = '';
}
function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { if (!r.ok) throw new Error('cart fetch failed'); return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); setCartLoading(false); })
    .catch(function() {
      setCartLoading(false);
      var body = document.getElementById('cartDrawerBody');
      /* Don't wipe already-painted (cached) contents on a transient fetch error */
      if (body && !body.innerHTML.trim()) body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
          '<p>Could not load bag. Please refresh.</p>' +
        '</div>';
    });
}
/* Apply a discount code to the cart via Shopify's /discount route (sets the code
   in the session), then re-read /cart.js so the drawer shows the applied savings.
   Discounts still finalise at checkout — this reflects them early in the bag. */
window.applyCartDiscount = function(code) {
  if (!code) return;
  setCartLoading(true);
  fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
    .then(function(r) { return r.json(); })
    .then(function(cart) { cacheCart(cart); _cartIntro = false; renderCartDrawer(cart); setCartLoading(false); })
    .catch(function() { setCartLoading(false); });
};
document.addEventListener('click', function(e) {
  var b = e.target.closest('[data-apply-promo]');
  if (!b) return;
  e.preventDefault();
  window.applyCartDiscount(b.getAttribute('data-apply-promo'));
});
/* ── Add-on identification (shared) ───────────────────────────────────────────
   A jersey can carry up to three add-on line items: a personalization fee, a
   patch, and a gift-box/packaging. These are NOT separate "products" from the
   shopper's point of view — they belong to the jersey and render nested under
   it. Defined at module scope so both the drawer renderer and the count badges
   agree on what counts as a real product vs. an add-on. */
function cartFeeVid() {
  try { return localStorage.getItem('jz_fee_vid') || ''; } catch (e) { return ''; }
}
function cartIsFeeItem(i) {
  var v = cartFeeVid();
  if (v && String(i.variant_id) === v) return true;
  if (/personalization/i.test(i.title || '')) return true;
  return false;
}
function cartIsPatchItem(i) {
  if (cartIsFeeItem(i)) return false;
  return !!(i.properties && i.properties['Patch for']);
}
function cartIsPkgItem(i) {
  if (cartIsFeeItem(i)) return false;
  return !!(i.properties && i.properties['Packaging for']);
}
function cartIsAddon(i) {
  return cartIsFeeItem(i) || cartIsPatchItem(i) || cartIsPkgItem(i);
}
/* The number to show on every cart badge: real products only (a jersey with a
   patch + print + gift box counts as 1, not 4). Falls back to item_count. */
function cartDisplayCount(cart) {
  if (!cart || !cart.items) return cart && cart.item_count || 0;
  return cart.items.reduce(function (n, i) {
    return cartIsAddon(i) ? n : n + (i.quantity || 0);
  }, 0);
}
/* Packaging product cached by the PDP (variant id / price / title / image) so the
   drawer can offer "Add gift box" on jerseys that don't have one yet. */
function cartPkgOffer() {
  try {
    var vid = localStorage.getItem('jz_pkg_vid');
    if (!vid) return null;
    var img = localStorage.getItem('jz_pkg_img') || '';
    if (img === 'null') img = '';
    return {
      vid:   vid,
      price: parseInt(localStorage.getItem('jz_pkg_price') || '0', 10) || 0,
      title: localStorage.getItem('jz_pkg_title') || 'Premium gift box',
      img:   img
    };
  } catch (e) { return null; }
}

function renderCartDrawer(cart) {
  var body  = document.getElementById('cartDrawerBody');
  var foot  = document.getElementById('cartDrawerFoot');
  if (!body || !foot) return;
  cacheCart(cart);
  /* Any successful render means content is on screen — kill the loader so it can
     never get stuck on (e.g. a cold-cache add used to leave the spinner spinning). */
  setCartLoading(false);

  /* Play the item entrance stagger only on open AND only when the cart actually
     changed — reopening an unchanged cart shouldn't re-animate ("refresh"). */
  var drawer = document.getElementById('cartDrawer');
  var sig = cart.item_count + '|' + cart.total_price + '|' +
            (cart.items || []).map(function(i) { return i.key + ':' + i.quantity; }).join(',');
  var changed = sig !== _lastCartSig;
  _lastCartSig = sig;
  var intro  = _cartIntro && changed;
  _cartIntro = false;
  if (drawer) drawer.classList.toggle('cart-drawer--intro', intro);

  cartApplyMeta(cart);

  /* Real products only — a lone fee / patch / gift-box left behind after its
     jersey was removed is NOT a product. If none remain, the bag must read as
     EMPTY (never a phantom subtotal / free-ship bar for orphaned add-ons). */
  var displayItems = (cart.items || []).filter(function(i) { return !cartIsAddon(i); });
  if (cart.item_count === 0 || displayItems.length === 0) {
    renderFreeShip(null);   /* hide the header free-shipping bar */
    body.innerHTML =
      '<div class="cart-drawer__empty">' +
        '<div class="cart-empty__icon-wrap">' +
          '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '</div>' +
        '<p class="cart-empty__title">Your bag is empty</p>' +
        '<p class="cart-empty__sub">Add a jersey to get started</p>' +
        '<a href="/collections/all" class="cart-empty__cta" onclick="closeCartDrawer()">Shop All Jerseys</a>' +
      '</div>';
    foot.innerHTML = '';   /* removes the footer ship bar + phantom subtotal */
    /* Strip any orphaned add-ons server-side (by unique line key) so the real
       cart total resets to 0 too — then just sync badges, no re-render loop. */
    if (cart.items && cart.items.length) {
      Promise.all(cart.items.map(function(orphan) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: orphan.key, quantity: 0 })
        });
      }))
      .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
      .then(function(c) { cartApplyMeta(c); })
      .catch(function() {});
    }
    return;
  }

  renderFreeShip(cart);

  /* Add-ons (fee / patch / packaging) are filtered out of the main list and
     rendered as nested sub-lines under their jersey. See module-level helpers. */
  var feeItems     = cart.items.filter(cartIsFeeItem);
  var patchItems   = cart.items.filter(cartIsPatchItem);
  var pkgItems     = cart.items.filter(cartIsPkgItem);

  /* Build fee lookup: jersey title → fee item (uses visible "For" property) */
  var feeByJerseyTitle = {};
  feeItems.forEach(function(fee) {
    var t = fee.properties && fee.properties['For'];
    if (t) feeByJerseyTitle[t] = fee;
    feeByJerseyTitle['__any'] = fee;
  });

  /* Build patch lookup: jersey title → ARRAY of patch items (multiple patches
     per jersey are allowed — each carries the visible "Patch for" property) */
  var patchByJerseyTitle = {};
  patchItems.forEach(function(patch) {
    var t = patch.properties && patch.properties['Patch for'];
    if (t) { (patchByJerseyTitle[t] = patchByJerseyTitle[t] || []).push(patch); }
  });

  /* Build packaging lookup: jersey title → gift-box item (visible "Packaging for") */
  var pkgByJerseyTitle = {};
  pkgItems.forEach(function(pkg) {
    var t = pkg.properties && pkg.properties['Packaging for'];
    if (t) pkgByJerseyTitle[t] = pkg;
  });

  body.innerHTML = displayItems.map(function(item, displayIdx) {
    var name         = esc(item.product_title);
    var variant      = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
    var imgSrc       = esc(item.image || '');

    /* Match fee to this item: by jersey title (visible "For" property) or fall back to single-fee any */
    /* Only treat THIS line as personalized when it actually carries the Name/Number/
       Personalization props — never just because a fee line exists. Stops a patch-only
       line (or a same-title twin) from inheriting the $4 personalization badge/charge. */
    var hasPersProps = !!(item.properties && (item.properties['Name'] || item.properties['Number'] || item.properties['Personalization']));
    var fee = hasPersProps ? (feeByJerseyTitle[item.product_title] || (feeItems.length === 1 ? feeItems[0] : null)) : null;
    /* Match patch(es) + packaging to this item by jersey title (visible link props) */
    var patches      = patchByJerseyTitle[item.product_title] || [];
    var pkg          = pkgByJerseyTitle[item.product_title]   || null;
    var patchTotal   = patches.reduce(function(s, pt) { return s + (pt.price || 0); }, 0);
    /* Item total = base jersey + personalization fee + patches + gift box, so the price
       shown on the line reflects everything added to it (the "+" badges below break it
       down). Re-renders on any change, so removing an add-on updates this total. */
    var displayPrice = item.price + (fee ? fee.price : 0) + patchTotal + (pkg ? pkg.price : 0);

    /* Personalization badge — read Name + Number, fall back to old "Personalization" property */
    var persHtml = '';
    if (fee) {
      var persText = '';
      if (item.properties) {
        var pName = item.properties['Name']   ? esc(item.properties['Name'])   : '';
        var pNum  = item.properties['Number'] ? esc(item.properties['Number']) : '';
        if (pName && pNum)      persText = pName + ' ' + pNum;
        else if (pName)         persText = pName;
        else if (pNum)          persText = pNum;
        else if (item.properties['Personalization']) persText = esc(item.properties['Personalization']);
      }
      persHtml =
        '<div class="cart-item__patch cart-item__patch--pers">' +
          '<span class="cart-item__patch-img cart-item__patch-icon" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M15.5 3.5 12 5.5 8.5 3.5 3.5 6.5 5.5 10l2-1.1V21h9V8.9l2 1.1 2-3.5-5-3z"/></svg>' +
          '</span>' +
          '<div class="cart-item__patch-info">' +
            '<span class="cart-item__patch-label">Personalized</span>' +
            (persText ? '<span class="cart-item__patch-name">' + persText + '</span>' : '') +
          '</div>' +
          '<span class="cart-item__patch-price">+' + formatMoney(fee.price) + '</span>' +
          '<button class="cart-item__patch-remove" type="button" data-act="remove-pers" data-key="' + esc(fee.key) + '" aria-label="Remove personalization">&#x2715;</button>' +
        '</div>';
    }

    /* Patch sub-lines: one per selected patch (image + name + remove ×) */
    var patchHtml = patches.map(function(patch) {
      var patchImg   = esc(patch.image || '');
      var patchTitle = esc(patch.product_title);
      var patchPrice = patch.price > 0 ? '<span class="cart-item__patch-price">+' + formatMoney(patch.price) + '</span>' : '';
      return '<div class="cart-item__patch">' +
          '<img class="cart-item__patch-img js-cart-img-zoom" src="' + patchImg + '" alt="" loading="lazy">' +
          '<div class="cart-item__patch-info">' +
            '<span class="cart-item__patch-label">Patch</span>' +
            '<span class="cart-item__patch-name">' + patchTitle + '</span>' +
          '</div>' +
          patchPrice +
          '<button class="cart-item__patch-remove" type="button" data-act="remove-line" data-key="' + esc(patch.key) + '" aria-label="Remove patch">&#x2715;</button>' +
        '</div>';
    }).join('');

    /* Gift-box / packaging sub-line — a CHECKBOX row: checked = box in the bag
       (untick removes it). When this jersey has no box yet and we know the
       packaging product (cached from the PDP), the same row renders unchecked
       as a one-tap add. */
    var tickSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    var pkgHtml = '';
    if (pkg) {
      var pkgImg   = esc(pkg.image || '');
      var pkgTitle = esc(pkg.product_title);
      var pkgPrice = pkg.price > 0 ? '<span class="cart-item__patch-price">+' + formatMoney(pkg.price) + '</span>' : '<span class="cart-item__patch-price">Free</span>';
      pkgHtml =
        '<div class="cart-item__patch cart-box is-checked">' +
          '<label class="cart-box__ctl">' +
            '<input type="checkbox" class="cart-box__check" checked data-act="box-toggle" data-key="' + esc(pkg.key) + '" aria-label="Remove gift box">' +
            '<span class="cart-box__tick" aria-hidden="true">' + tickSvg + '</span>' +
          '</label>' +
          (pkgImg ? '<img class="cart-item__patch-img js-cart-img-zoom" src="' + pkgImg + '" alt="" loading="lazy">' : '') +
          '<div class="cart-item__patch-info">' +
            '<span class="cart-item__patch-label">Gift Box</span>' +
            '<span class="cart-item__patch-name">' + pkgTitle + '</span>' +
          '</div>' +
          pkgPrice +
        '</div>';
    } else {
      var offer = cartPkgOffer();
      if (offer) {
        pkgHtml =
          '<div class="cart-item__patch cart-box cart-box--offer">' +
            '<label class="cart-box__ctl">' +
              '<input type="checkbox" class="cart-box__check" data-act="box-toggle" data-vid="' + esc(offer.vid) + '" data-for="' + name + '" aria-label="Add gift box">' +
              '<span class="cart-box__tick" aria-hidden="true">' + tickSvg + '</span>' +
            '</label>' +
            (offer.img ? '<img class="cart-item__patch-img" src="' + esc(offer.img) + '" alt="" loading="lazy">' : '') +
            '<div class="cart-item__patch-info">' +
              '<span class="cart-item__patch-label">Add Gift Box</span>' +
              '<span class="cart-item__patch-name">' + esc(offer.title) + '</span>' +
            '</div>' +
            '<span class="cart-item__patch-price">' + (offer.price > 0 ? '+' + formatMoney(offer.price) : 'Free') + '</span>' +
          '</div>';
      }
    }

    var hasLinks = !!(fee || patches.length || pkg);

    return '<div class="cart-item" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '" data-haslinks="' + (hasLinks ? '1' : '') + '" style="--ci:' + displayIdx + '">' +
      '<img class="cart-item__img js-cart-img-zoom" src="' + imgSrc + '" alt="' + name + '" loading="lazy">' +
      '<div class="cart-item__info">' +
        '<div class="cart-item__name">' + name + '</div>' +
        (variant ? '<div class="cart-item__variant">' + variant + '</div>' : '') +
        persHtml +
        patchHtml +
        pkgHtml +
        '<div class="cart-item__price">' + formatMoney(displayPrice) + '</div>' +
        '<div class="cart-item__qty">' +
          '<button class="cart-item__qty-btn" type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button>' +
          '<span class="cart-item__qty-pick">' +
            '<select class="cart-item__qty-sel" data-act="qty-sel" aria-label="Choose quantity">' + (function() {
              var max = Math.max(10, item.quantity), o = '';
              for (var q = 1; q <= max; q++) o += '<option value="' + q + '"' + (q === item.quantity ? ' selected' : '') + '>' + q + '</option>';
              return o;
            })() + '</select>' +
          '</span>' +
          '<button class="cart-item__qty-btn" type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<button class="cart-item__remove" type="button" data-act="remove" aria-label="Remove ' + name + '">&#x2715;</button>' +
    '</div>';
  }).join('');
  /* ── Discount: show the applied code + savings, or a tap-to-apply suggestion ── */
  var cdEl = document.getElementById('cartDrawer');
  var promoCode  = cdEl ? (cdEl.getAttribute('data-promo-code')  || '').trim() : '';
  var promoLabel = cdEl ? (cdEl.getAttribute('data-promo-label') || '').trim() : '';
  var discApps   = cart.cart_level_discount_applications || [];
  var savedCents = cart.total_discount || 0;
  var hasDiscount = savedCents > 0 || discApps.length > 0;
  var tagSvg = '<svg class="cart-promo__ico" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
  var discountRow = '';
  if (hasDiscount) {
    var dCode = (discApps[0] && (discApps[0].title || discApps[0].code)) || (promoCode || 'Discount');
    discountRow =
      '<div class="cart-drawer__discount">' +
        '<span class="cart-drawer__discount-tag">' + tagSvg + '<span>Discount &middot; ' + esc(dCode) + '</span></span>' +
        '<span class="cart-drawer__discount-amt">&minus;' + formatMoney(savedCents) + '</span>' +
      '</div>';
  }
  var promoRow = '';
  if (!hasDiscount && promoCode) {
    promoRow =
      '<button type="button" class="cart-drawer__promo" data-apply-promo="' + esc(promoCode) + '">' +
        '<span class="cart-drawer__promo-info">' + tagSvg +
          '<span class="cart-drawer__promo-text">' +
            (promoLabel ? '<strong>' + esc(promoLabel) + '</strong>' : '') +
            '<span class="cart-drawer__promo-code">Code ' + esc(promoCode) + '</span>' +
          '</span>' +
        '</span>' +
        '<span class="cart-drawer__promo-apply">Apply</span>' +
      '</button>';
  }
  var subOrig = (hasDiscount && cart.original_total_price && cart.original_total_price > cart.total_price)
    ? '<s class="cart-drawer__subtotal-orig">' + formatMoney(cart.original_total_price) + '</s> ' : '';
  foot.innerHTML =
    /* free-shipping bar lives once at the top of the drawer (#cartFreeShip) —
       no duplicate here in the footer */
    '<div class="cart-delivery">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1.5"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.2"/><circle cx="18.5" cy="18.5" r="2.2"/></svg>' +
      '<div class="cart-delivery__txt">' +
        '<span class="cart-delivery__label">Estimated delivery</span>' +
        '<span class="cart-delivery__date">3–4 weeks</span>' +
      '</div>' +
    '</div>' +
    promoRow +
    discountRow +
    '<div class="cart-drawer__subtotal">' +
      '<span class="cart-drawer__subtotal-label">Subtotal</span>' +
      '<span class="cart-drawer__subtotal-price">' + subOrig + formatMoney(cart.total_price) + '</span>' +
    '</div>' +
    '<a href="/checkout" class="cart-drawer__checkout cart-drawer__checkout--animate">Proceed to Checkout &nbsp;&rarr;</a>' +
    '<div class="cart-drawer__secure">' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>' +
      'Secure checkout &middot; Taxes &amp; shipping calculated at checkout' +
    '</div>';
}
/* Lightweight reconcile — sync counts + subtotal WITHOUT rebuilding the item list
   (rebuilding would replay the entrance stagger on every click = the old flicker bug) */
function cartApplyMeta(cart) {
  cacheCart(cart);
  var badge = document.getElementById('cartDrawerCount');
  var nav   = document.getElementById('cartCount');
  var mob   = document.getElementById('mobileCartCount');
  var sub   = document.querySelector('.cart-drawer__subtotal-price');
  /* Show the number of real products, not raw line items — a jersey plus its
     patch / print / gift box reads as 1, so the badge never says "4". */
  var count = cartDisplayCount(cart);
  if (badge) badge.textContent = count;
  if (nav)   { nav.textContent = count; nav.classList.add('pop'); setTimeout(function() { nav.classList.remove('pop'); }, 500); }
  if (mob)   mob.textContent = count;
  if (sub)   sub.textContent = formatMoney(cart.total_price);
  renderFreeShip(cart);   /* keep the single header free-ship bar in sync on qty changes */
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
}

/* Toggle the slim loading bar in the drawer header during cart network activity */
function setCartLoading(on) {
  var d = document.getElementById('cartDrawer');
  if (d) d.classList.toggle('cart-drawer--loading', !!on);
}

/* Free-shipping progress bar — unlocks at $120 (12000 cents).
   v2: the truck RIDES the bar to a flag at the goal, with a % chip on the right.
   The bar is built once and then mutated in place so the fill width (and the
   truck with it) glides between states instead of snapping on every re-render. */
var FREE_SHIP_THRESHOLD = 12000;
function renderFreeShip(cart) {
  var fs = document.getElementById('cartFreeShip');
  if (!fs) return;
  if (!cart || cart.item_count === 0) { fs.style.display = 'none'; fs.innerHTML = ''; fs.classList.remove('is-unlocked'); return; }
  fs.style.display = '';
  var total     = cart.total_price;
  var remaining = FREE_SHIP_THRESHOLD - total;
  var pct       = Math.max(0, Math.min(100, Math.round(total / FREE_SHIP_THRESHOLD * 100)));
  var unlocked  = remaining <= 0;
  var msg = unlocked
    ? 'You’ve unlocked <strong>FREE worldwide shipping</strong> 🎉'
    : '<strong>' + formatMoney(remaining) + '</strong> away from <strong>FREE shipping</strong>';
  var chip = unlocked ? 'FREE' : pct + '%';
  fs.classList.toggle('is-unlocked', unlocked);

  var fill = fs.querySelector('.cart-freeship__fill');
  if (fill) {
    /* Structure exists — mutate in place so width/left transitions play */
    var txt = fs.querySelector('.cart-freeship__text');
    var pc  = fs.querySelector('.cart-freeship__pct');
    var tr  = fs.querySelector('.cart-freeship__truck');
    if (txt) txt.innerHTML = msg;
    if (pc)  pc.textContent = chip;
    fill.style.width = pct + '%';
    if (tr) tr.style.left = pct + '%';
    return;
  }

  var truck = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1.5"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.2"/><circle cx="18.5" cy="18.5" r="2.2"/></svg>';
  var check = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  fs.innerHTML =
    '<div class="cart-freeship__row">' +
      '<span class="cart-freeship__text">' + msg + '</span>' +
      '<span class="cart-freeship__pct">' + chip + '</span>' +
    '</div>' +
    '<div class="cart-freeship__track">' +
      '<div class="cart-freeship__fill" style="width:0%"></div>' +
      '<span class="cart-freeship__truck" style="left:0%">' + truck + '</span>' +
      '<span class="cart-freeship__goal" aria-hidden="true">' + check + '</span>' +
    '</div>';
  /* First paint: sweep the fill from 0 to the real value on the next frame */
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      var f = fs.querySelector('.cart-freeship__fill');
      var t = fs.querySelector('.cart-freeship__truck');
      if (f) f.style.width = pct + '%';
      if (t) t.style.left  = pct + '%';
    });
  });
}

/* Quantity changes are KEY-based (race-proof, unlike positional line numbers) and debounced:
   the number updates instantly on tap, only the final value is sent to Shopify. */
var _cartQtyTimers = {};
function cartSetQty(key, qty) {
  if (!key) return;
  clearTimeout(_cartQtyTimers[key]);
  _cartQtyTimers[key] = setTimeout(function() {
    delete _cartQtyTimers[key];
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function(cart) {
      cartApplyMeta(cart);
      /* If the line is gone or out of sync with what we showed, do a full reconcile */
      var ok = cart.items.some(function(i) { return i.key === key && i.quantity === qty; });
      if (!ok) renderCartDrawer(cart);
    })
    .catch(function() { refreshCartDrawer(); });
  }, 260);
}

function cartChangeZero(k) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: k, quantity: 0 })
  }).then(function(r) { if (!r.ok) throw new Error(); return r.json(); });
}

/* Remove personalization: zero the $4 fee line, then strip Name/Number/Personalization
   from the jersey line (re-keys the line) so the print is actually cancelled, not just
   un-charged. Keeps any 'Patch' property intact (that's a separate add-on). */
function cartRemovePersonalization(feeKey, jerseyKey) {
  return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    var jersey = cart.items.filter(function(i) { return i.key === jerseyKey; })[0];
    var step = feeKey ? cartChangeZero(feeKey) : Promise.resolve(cart);
    return step.then(function(updated) {
      if (!jersey || !jersey.properties) return updated;
      var np = {};
      Object.keys(jersey.properties).forEach(function(k) {
        if (k !== 'Name' && k !== 'Number' && k !== 'Personalization') np[k] = jersey.properties[k];
      });
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: jerseyKey, quantity: jersey.quantity, properties: np })
      }).then(function(r) { if (!r.ok) throw new Error(); return r.json(); });
    });
  }).then(function(cart) {
    if (!cart || !cart.items) { refreshCartDrawer(); return; }
    renderCartDrawer(cart);
    setCartLoading(false);
  }).catch(function() { setCartLoading(false); refreshCartDrawer(); });
}

/* Returns the final cart. When the jersey has a linked fee/patch/box, cascade-remove
   those too — UNLESS another jersey line with the same title remains (add-ons link by
   title, so a surviving twin still owns them). */
function cartRemoveCascade(key, withLinks) {
  if (!withLinks) return cartChangeZero(key);
  return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    var jersey = cart.items.filter(function(i) { return i.key === key; })[0];
    var title  = jersey ? jersey.product_title : null;
    var twins  = cart.items.filter(function(i) {
      return i.key !== key && !cartIsAddon(i) && i.product_title === title;
    });
    return cartChangeZero(key).then(function(updated) {
      if (!title || twins.length) return updated;   /* a twin jersey keeps the add-ons */
      var links = updated.items.filter(function(i) {
        return i.properties && (i.properties['For'] === title || i.properties['Patch for'] === title || i.properties['Packaging for'] === title);
      });
      if (!links.length) return updated;
      /* Remove every linked line, one at a time (Shopify serializes cart writes),
         then re-read the cart once so the caller gets the true final state. */
      return links.reduce(function(p, link) {
        return p.then(function() { return cartChangeZero(link.key); });
      }, Promise.resolve())
      .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); });
    });
  });
}

/* Delegated controls for the cart body — one listener, survives every re-render, no inline handlers */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('#cartDrawerBody [data-act]');
  if (!btn) return;
  var act  = btn.getAttribute('data-act');
  var item = btn.closest('.cart-item');

  if (act === 'inc' || act === 'dec') {
    if (!item) return;
    var cur  = parseInt(item.getAttribute('data-qty'), 10) || 1;
    var next = act === 'inc' ? cur + 1 : cur - 1;
    if (next < 1) { cartRemoveItem(item); return; }   /* stepping below 1 removes the line */
    item.setAttribute('data-qty', next);
    var sel = item.querySelector('.cart-item__qty-sel');
    if (sel) {
      if (!sel.querySelector('option[value="' + next + '"]')) {
        var opt = document.createElement('option');
        opt.value = next; opt.textContent = next;
        sel.appendChild(opt);
      }
      sel.value = String(next);
    }
    cartSetQty(item.getAttribute('data-key'), next);
    return;
  }
  if (act === 'remove')      { if (item) cartRemoveItem(item); return; }
  if (act === 'remove-pers') {  /* personalization — drop the $4 fee line AND clear the
                                   Name/Number off the jersey so it isn't printed for free */
    var persEl = btn.closest('.cart-item__patch');
    if (persEl) { persEl.classList.add('cart-item__patch--removing'); persEl.style.pointerEvents = 'none'; }
    var jKey = item ? item.getAttribute('data-key') : '';
    cartRemovePersonalization(btn.getAttribute('data-key'), jKey);
    return;
  }
  if (act === 'remove-line') {  /* patch sub-line — fade it out, then re-render so the
                                   parent jersey price drops the patch cost (not just the subtotal) */
    var patchEl = btn.closest('.cart-item__patch');
    if (patchEl) { patchEl.classList.add('cart-item__patch--removing'); patchEl.style.pointerEvents = 'none'; }
    cartChangeZero(btn.getAttribute('data-key'))
      .then(function(cart) {
        renderCartDrawer(cart);   /* recomputes per-item price + subtotal (was: subtotal only → stale price) */
      })
      .catch(function() { refreshCartDrawer(); });
    return;
  }
});

/* Delegated CHANGE events — the qty dropdown and the gift-box checkbox */
document.addEventListener('change', function(e) {
  var t = e.target;
  if (!t || !t.getAttribute || t.getAttribute('data-act') === null || !t.closest('#cartDrawerBody')) return;
  var act = t.getAttribute('data-act');

  if (act === 'qty-sel') {
    var item = t.closest('.cart-item');
    if (!item) return;
    var q = parseInt(t.value, 10) || 1;
    item.setAttribute('data-qty', q);
    cartSetQty(item.getAttribute('data-key'), q);
    return;
  }

  if (act === 'box-toggle') {
    var row = t.closest('.cart-box');
    t.disabled = true;                          /* one action at a time */
    var done = function(cart) { if (cart && cart.items) renderCartDrawer(cart); else refreshCartDrawer(); };
    var key = t.getAttribute('data-key');
    if (key) {
      /* untick = remove the gift box (fade the row out first) */
      if (row) { row.classList.remove('is-checked'); row.classList.add('cart-item__patch--removing'); row.style.pointerEvents = 'none'; }
      cartChangeZero(key).then(done).catch(function() { refreshCartDrawer(); });
    } else {
      /* tick = add the gift box linked to this jersey */
      if (row) row.classList.add('is-checked');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(t.getAttribute('data-vid'), 10),
          quantity: 1,
          properties: { 'Packaging for': t.getAttribute('data-for') || '' }
        })
      })
      .then(function(r) { if (!r.ok) throw new Error(); return fetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(done)
      .catch(function() { if (row) row.classList.remove('is-checked'); refreshCartDrawer(); });
    }
  }
});

/* Play the collapse animation, and once BOTH it and the network settle, rebuild the
   list from the server's cart (no entrance stagger outside open, so no flash). A full
   rebuild — not a lone node removal — is what keeps the drawer honest: empty state,
   orphaned add-on cleanup, per-item prices, free-ship bar and subtotal all reconcile. */
function cartRemoveItem(item) {
  if (item.classList.contains('cart-item--removing')) return;
  var key       = item.getAttribute('data-key');
  var withLinks = item.getAttribute('data-haslinks') === '1';
  if (_cartQtyTimers[key]) { clearTimeout(_cartQtyTimers[key]); delete _cartQtyTimers[key]; }
  /* Measure the real row height so the max-height collapse glides, not jumps */
  item.style.setProperty('--ci-h', item.offsetHeight + 'px');
  item.classList.add('cart-item--removing');
  item.style.pointerEvents = 'none';

  var collapse = new Promise(function(res) { setTimeout(res, 400); });
  var network  = cartRemoveCascade(key, withLinks).catch(function() { return null; });

  Promise.all([network, collapse]).then(function(r) {
    var cart = r[0];
    if (!cart || !cart.items) { refreshCartDrawer(); return; }
    renderCartDrawer(cart);   /* handles empty state + orphan cleanup + badges itself */
  });
}

/* ═══════════════════════════════════════════════
   QUICK VIEW
   ═══════════════════════════════════════════════ */
function openQuickView(handle, collImgs, prodType) {
  var modal = document.getElementById('quickView');
  var body  = document.getElementById('quickViewBody');
  if (!modal || !body) return;
  body.innerHTML =
    '<div class="qv-skeleton">' +
      '<div class="qv-skeleton__gallery skeleton"></div>' +
      '<div class="qv-skeleton__info">' +
        '<div class="skeleton" style="width:30%;height:10px"></div>' +
        '<div class="skeleton" style="width:85%;height:20px"></div>' +
        '<div class="skeleton" style="width:70%;height:20px"></div>' +
        '<div class="skeleton" style="width:35%;height:26px;margin-top:6px"></div>' +
        '<div class="skeleton" style="width:22%;height:10px;margin-top:10px"></div>' +
        '<div class="qv-sk-sizes"><div class="skeleton"></div><div class="skeleton"></div><div class="skeleton"></div><div class="skeleton"></div></div>' +
        '<div class="skeleton qv-sk-cta" style="width:100%;height:48px"></div>' +
      '</div>' +
    '</div>';
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function(p) { renderQuickView(p, collImgs || '', prodType || ''); })
    .catch(function() {
      body.innerHTML =
        '<div class="quick-view__loading" style="flex-direction:column;gap:12px">' +
          '<p style="color:var(--muted);font-size:13px">Could not load product.</p>' +
          '<a href="/products/' + esc(handle) + '" style="color:var(--gold);font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase">View Product &rarr;</a>' +
        '</div>';
    });
}
function closeQuickView() {
  var modal = document.getElementById('quickView');
  if (!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
function renderQuickView(p, collImgs, prodType) {
  var body = document.getElementById('quickViewBody');
  if (!body) return;
  var firstImg = p.images && p.images.length ? p.images[0] : '';
  var variant  = p.variants && p.variants[0];
  var price    = variant ? formatMoney(variant.price) : '';
  var compare  = variant && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
  var pctOff   = (variant && compare) ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) : 0;

  var logosHtml = prodType ? '<div class="qv-product-type">' + esc(prodType) + '</div>' : '';

  var thumbs = (p.images || []).slice(0, 6).map(function(src, i) {
    return '<img class="qv-thumb' + (i === 0 ? ' active' : '') + '" ' +
      'src="' + esc(src + '&width=80') + '" data-full="' + esc(src + '&width=700') + '" ' +
      'loading="lazy" onclick="qvSetImg(this)" alt="">';
  }).join('');

  var sizeOpt  = p.options.find(function(o) { return /size/i.test(o.name); });
  var otherOpt = p.options.find(function(o) { return !/size/i.test(o.name) && o.name !== 'Title'; });
  function buildOptions(opt) {
    if (!opt) return '';
    return '<div class="qv-label">' + esc(opt.name) + '</div>' +
      '<div class="qv-sizes">' +
        opt.values.map(function(v, i) {
          return '<button class="qv-size-btn' + (i === 0 ? ' active' : '') + '" onclick="qvSelectOpt(this)">' + esc(v) + '</button>';
        }).join('') +
      '</div>';
  }

  body.innerHTML =
    '<div class="qv-gallery">' +
      /* The big picture links straight into the product page */
      '<a class="qv-main-wrap" href="/products/' + esc(p.handle) + '" aria-label="View ' + esc(p.title) + '">' +
        '<img class="qv-main-img" id="qvMainImg" src="' + esc(firstImg ? firstImg + '&width=700' : '') + '" alt="' + esc(p.title) + '" loading="eager">' +
      '</a>' +
      (p.images && p.images.length > 1 ? '<div class="qv-thumbs">' + thumbs + '</div>' : '') +
    '</div>' +
    '<div class="qv-info">' +
      logosHtml +
      '<a href="/products/' + esc(p.handle) + '" class="qv-title">' + esc(p.title) + '</a>' +
      '<div class="qv-price-row" id="qvPriceRow">' +
        '<span class="qv-price' + (compare ? ' sale' : '') + '" id="qvPrice">' + price + '</span>' +
        (compare ? '<span class="qv-compare" id="qvCompare">' + compare + '</span>' : '<span class="qv-compare" id="qvCompare" style="display:none"></span>') +
        (pctOff  ? '<span class="qv-badge" id="qvBadge">'  + pctOff + '% OFF</span>' : '<span class="qv-badge" id="qvBadge" style="display:none"></span>') +
      '</div>' +
      buildOptions(sizeOpt) +
      buildOptions(otherOpt) +
      '<input type="hidden" id="qvVariantId" value="' + esc(variant ? String(variant.id) : '') + '">' +
      '<button class="btn-atb qv-atb" id="qvAtb" onclick="qvAddToBag()"' + (!variant || !variant.available ? ' disabled' : '') + '>' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        (variant && variant.available ? 'Add to Bag' : 'Sold Out') +
      '</button>' +
      '<a href="/products/' + esc(p.handle) + '" class="qv-view-full">View Full Details &rarr;</a>' +
    '</div>';

  /* Must be assigned here, not via a <script> tag in the markup above:
     scripts inserted through innerHTML never execute, which left size
     selection dead and always added the first variant. */
  window._qvVariants = p.variants || [];
}
function qvSetImg(thumb) {
  var main = document.getElementById('qvMainImg');
  if (!main) return;
  main.style.opacity = '0';
  setTimeout(function() {
    main.src = thumb.dataset.full;
    main.style.transition = 'opacity 0.2s ease';
    main.style.opacity = '1';
  }, 100);
  document.querySelectorAll('.qv-thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}
function qvSelectOpt(btn) {
  var group = btn.closest('.qv-sizes');
  if (!group) return;
  group.querySelectorAll('.qv-size-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var variants = window._qvVariants || [];
  var selected = [];
  document.querySelectorAll('.qv-sizes').forEach(function(g) {
    var active = g.querySelector('.qv-size-btn.active');
    if (active) selected.push(active.textContent.trim());
  });
  var match = variants.find(function(v) {
    return selected.every(function(s) { return v.options.indexOf(s) !== -1; });
  });
  if (!match) return;
  document.getElementById('qvVariantId').value = match.id;
  var priceEl   = document.getElementById('qvPrice');
  var compareEl = document.getElementById('qvCompare');
  var badgeEl   = document.getElementById('qvBadge');
  if (priceEl) {
    priceEl.textContent = formatMoney(match.price);
    if (match.compare_at_price > match.price) {
      priceEl.classList.add('sale');
      if (compareEl) { compareEl.textContent = formatMoney(match.compare_at_price); compareEl.style.display = ''; }
      var pct = Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100);
      if (badgeEl) { badgeEl.textContent = pct + '% OFF'; badgeEl.style.display = ''; }
    } else {
      priceEl.classList.remove('sale');
      if (compareEl) { compareEl.textContent = ''; compareEl.style.display = 'none'; }
      if (badgeEl)   { badgeEl.textContent   = ''; badgeEl.style.display   = 'none'; }
    }
  }
  var atb = document.getElementById('qvAtb');
  if (atb) {
    atb.disabled = !match.available;
    atb.innerHTML = (match.available
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>Add to Bag'
      : 'Sold Out');
  }
}
function qvAddToBag() {
  var vid = document.getElementById('qvVariantId');
  var btn = document.getElementById('qvAtb');
  if (!vid || !vid.value || !btn) return;
  btn.textContent = 'Adding…';
  btn.disabled = true;
  btn.classList.add('adding');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(vid.value, 10), quantity: 1 })
  })
  .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
  .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
  .then(function(cart) {
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg> Added!';
    btn.classList.remove('adding');
    btn.classList.add('added');
    renderCartDrawer(cart);
    setTimeout(function() { closeQuickView(); setTimeout(function() { openCartDrawer(); }, 250); }, 900);
  })
  .catch(function() {
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>Add to Bag';
    btn.disabled = false;
    btn.classList.remove('adding');
  });
}

/* ─── Patches grid — lazy build on first modal open ─────────────
   The 50 patch cards are NOT in the page HTML; only a compact JSON
   blob (#patchesData) ships. We build the cards the first time the
   modal opens. Keeps every product page's DOM ~50 nodes lighter. */
function jzEscHtml(s) {
  return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  });
}
function buildPatchesGrid() {
  var grid = document.getElementById('patchesGrid');
  if (!grid || grid.dataset.built === '1') return;
  var dataEl = document.getElementById('patchesData');
  if (!dataEl) return;
  var items;
  try { items = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
  var check = '<span class="patch-pick__check" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
  var html = '';
  for (var i = 0; i < items.length; i++) {
    var p = items[i];
    var t = p.t || '';
    var name = t.length > 28 ? t.slice(0, 27) + '…' : t;
    var img = p.im
      ? '<img class="cs-card__img" src="' + jzEscHtml(p.im) + '" alt="' + jzEscHtml(t) + '" loading="lazy" width="120" height="120">'
      : '<div class="cs-card__img-ph"></div>';
    html += '<button type="button" class="cs-card patch-pick js-patch-pick"'
      + ' data-handle="' + jzEscHtml(p.h) + '"'
      + ' data-variant-id="' + jzEscHtml(p.v) + '"'
      + ' data-title="' + jzEscHtml(t) + '"'
      + ' data-image="' + jzEscHtml(p.i2) + '"'
      + ' data-price="' + jzEscHtml(p.p) + '"'
      + ' data-price-cents="' + jzEscHtml(p.pc) + '"'
      + ' data-coll-imgs="' + jzEscHtml(p.ci) + '"'
      + ' data-collections="' + jzEscHtml(p.co) + '"'
      + ' data-type="' + jzEscHtml(p.ty) + '"'
      + ' aria-label="Select ' + jzEscHtml(t) + '">'
      + '<div class="cs-card__img-wrap">' + img
      + (p.sug ? '<span class="cs-card__suggest">Suggested</span>' : '')
      + (p.cmp ? '<span class="cs-card__badge">Sale</span>' : '')
      + check
      + '</div>'
      + '<div class="cs-card__body"><p class="cs-card__name">' + jzEscHtml(name) + '</p>'
      + '<div class="cs-card__price-row"><span class="cs-card__price">' + jzEscHtml(p.p) + '</span>'
      + (p.cmp ? '<span class="cs-card__compare">' + jzEscHtml(p.cmp) + '</span>' : '')
      + '</div></div></button>';
  }
  grid.innerHTML = html;
  grid.dataset.built = '1';
}

/* ─── Patches modal — open / close ─── */
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-open-patches]')) {
    var m = document.getElementById('patchesModal');
    if (m) {
      buildPatchesGrid();
      /* Portal to <body> so position:fixed centers on the viewport — the modal
         lives inside the personalization block, whose transforms otherwise make
         the "fixed" overlay anchor to that block (pinning it off-screen at top). */
      if (m.parentNode !== document.body) document.body.appendChild(m);
      m.classList.add('is-open');
      m.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      /* Auto-focus search after the open animation settles */
      var s = document.getElementById('patchesSearch');
      if (s) setTimeout(function() { s.focus({ preventScroll: true }); }, 320);
    }
  }
  if (e.target.closest('[data-close-patches]')) {
    var m = document.getElementById('patchesModal');
    if (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }
});
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var m = document.getElementById('patchesModal');
    if (m && m.classList.contains('is-open')) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }
});

/* ─── Cart image zoom — tap a thumbnail to enlarge in a lightbox ─── */
document.addEventListener('click', function(e) {
  var img = e.target.closest('.js-cart-img-zoom');
  if (!img) return;
  e.preventDefault();
  e.stopPropagation();

  /* Build a hi-res URL via Shopify's width param (strips any cached size suffix) */
  var src = img.getAttribute('src') || '';
  var hires = src.replace(/_\d+x\d+\./, '.').replace(/[?&]width=\d+/, '');
  hires += (hires.indexOf('?') === -1 ? '?' : '&') + 'width=900';

  var box = document.createElement('div');
  box.className = 'cart-zoom';
  box.innerHTML =
    '<div class="cart-zoom__backdrop"></div>' +
    '<img class="cart-zoom__img" src="' + hires + '" alt="">' +
    '<button class="cart-zoom__close" type="button" aria-label="Close">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button>';
  document.body.appendChild(box);
  requestAnimationFrame(function() { box.classList.add('is-open'); });

  function close() {
    box.classList.remove('is-open');
    setTimeout(function() { box.remove(); }, 280);
  }
  box.querySelector('.cart-zoom__backdrop').addEventListener('click', close);
  box.querySelector('.cart-zoom__close').addEventListener('click', close);
  box.querySelector('.cart-zoom__img').addEventListener('click', close);
  document.addEventListener('keydown', function esc(ev) {
    if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
  });
});

/* ─── Multiple patch selection ────────────────────────────────────────────────
   window.jzPatches is the single source of truth: an array of selected patches.
   The modal stays OPEN so the user can pick several; each pick toggles. Selected
   patches render as chips under the "Add a patch" card and sum into the price. */
window.jzPatches = window.jzPatches || [];

function jzPatchIndex(v) {
  var arr = window.jzPatches || [];
  for (var i = 0; i < arr.length; i++) { if (arr[i].variantId === v) return i; }
  return -1;
}
function renderSelectedPatches() {
  var list = document.getElementById('patchSelectedList');
  if (!list) return;
  var arr = window.jzPatches || [];
  /* 2+ patches → compact picture-only chips (name/label hidden via CSS) */
  list.classList.toggle('patch-selected-list--multi', arr.length > 1);
  if (!arr.length) { list.innerHTML = ''; list.hidden = true; }
  else {
    list.hidden = false;
    list.innerHTML = arr.map(function(p) {
      return '<div class="patch-card patch-card--selected" data-variant-id="' + jzEscHtml(p.variantId) + '"'
        + ' data-handle="' + jzEscHtml(p.handle) + '" data-coll-imgs="' + jzEscHtml(p.collImgs) + '" data-type="' + jzEscHtml(p.type) + '">'
        + '<button type="button" class="patch-card__view" aria-label="View ' + jzEscHtml(p.title) + '">'
          + '<img class="patch-card__selected-img" src="' + jzEscHtml(p.image) + '" alt="' + jzEscHtml(p.title) + '">'
          + '<span class="patch-card__body">'
            + '<strong class="patch-card__selected-label">Patch selected</strong>'
            + '<span class="patch-card__selected-name">' + jzEscHtml(p.title) + '</span>'
          + '</span>'
        + '</button>'
        + '<button type="button" class="patch-card__remove" data-remove-patch="' + jzEscHtml(p.variantId) + '" aria-label="Remove ' + jzEscHtml(p.title) + '">'
          + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button>'
      + '</div>';
    }).join('');
  }
  /* Reflect count on the modal's Done button + grid check states */
  var doneLbl = document.getElementById('patchesDoneLabel');
  if (doneLbl) doneLbl.textContent = arr.length ? ('Done · ' + arr.length + ' selected') : 'Done';
}
window.renderSelectedPatches = renderSelectedPatches;

/* Toggle a patch on modal-grid click (keeps the modal open for multi-pick) */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.js-patch-pick');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var v = btn.dataset.variantId || '';
  if (!v) return;
  window.jzPatches = window.jzPatches || [];
  var idx = jzPatchIndex(v);
  if (idx !== -1) {
    window.jzPatches.splice(idx, 1);
    btn.classList.remove('is-selected');
  } else {
    window.jzPatches.push({
      variantId:  v,
      title:      btn.dataset.title    || '',
      image:      btn.dataset.image    || '',
      handle:     btn.dataset.handle   || '',
      collImgs:   btn.dataset.collImgs || '',
      type:       btn.dataset.type     || '',
      price:      btn.dataset.price    || '',
      priceCents: btn.dataset.priceCents || '0'
    });
    btn.classList.add('is-selected');
  }
  renderSelectedPatches();
  if (window.jzSyncPatchPrice) window.jzSyncPatchPrice();
});

/* Click a selected patch chip → open its quick-view popup */
document.addEventListener('click', function(e) {
  var view = e.target.closest('#patchSelectedList .patch-card__view');
  if (!view) return;
  e.preventDefault();
  var card = view.closest('.patch-card');
  if (!card) return;
  if (card.dataset.handle && typeof openQuickView === 'function') {
    openQuickView(card.dataset.handle, card.dataset.collImgs || '', card.dataset.type || '');
  }
});

/* Remove one selected patch (chip × or the grid check toggling off) */
document.addEventListener('click', function(e) {
  var rm = e.target.closest('[data-remove-patch]');
  if (!rm) return;
  e.preventDefault();
  e.stopPropagation();
  var v = rm.getAttribute('data-remove-patch');
  var idx = jzPatchIndex(v);
  if (idx !== -1) window.jzPatches.splice(idx, 1);
  var pick = document.querySelector('.js-patch-pick[data-variant-id="' + v + '"]');
  if (pick) pick.classList.remove('is-selected');
  renderSelectedPatches();
  if (window.jzSyncPatchPrice) window.jzSyncPatchPrice();
});

/* ─── Patches modal — search + collection chip filtering combined ─── */
(function() {
  var search   = document.getElementById('patchesSearch');
  var clearBtn = document.getElementById('patchesSearchClear');
  var grid     = document.getElementById('patchesGrid');
  var chips    = document.querySelectorAll('.patches-chip');
  if (!grid) return;
  var wrap   = search ? search.parentElement : null;
  var activeColl = 'all';

  function applyFilter() {
    var q = search ? search.value.toLowerCase().trim() : '';
    var hits = 0;
    /* Query fresh each call — cards are built lazily on first modal open */
    var cards = grid.querySelectorAll('.cs-card');
    cards.forEach(function(card) {
      var nameEl = card.querySelector('.cs-card__name');
      var name   = nameEl ? nameEl.textContent.toLowerCase() : '';
      var nameMatch = !q || name.indexOf(q) !== -1;

      var collMatch = true;
      if (activeColl !== 'all') {
        var cols = (card.dataset.collections || '').split(',').filter(Boolean);
        collMatch = cols.indexOf(activeColl) !== -1;
      }

      var match = nameMatch && collMatch;
      card.style.display = match ? '' : 'none';
      if (match) hits++;
    });
    if (wrap) {
      wrap.classList.toggle('has-text', q.length > 0);
      wrap.classList.toggle('no-results', hits === 0 && (q.length > 0 || activeColl !== 'all'));
    }
  }

  if (search) search.addEventListener('input', applyFilter);
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      search.value = '';
      applyFilter();
      search.focus();
    });
  }

  chips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      chips.forEach(function(c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-selected', 'false');
      });
      chip.classList.add('is-active');
      chip.setAttribute('aria-selected', 'true');
      activeColl = chip.dataset.coll || 'all';
      applyFilter();
    });
  });
})();

/* ─── Quick View click handler ─── */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.js-quick-view');
  if (!btn) return;
  e.preventDefault();
  var handle   = btn.dataset.handle;
  var collImgs = btn.dataset.collImgs || '';
  var prodType = btn.dataset.type     || '';
  if (handle) openQuickView(handle, collImgs, prodType);
});

/* ═══════════════════════════════════════════════
   MAGIC PASS — spotlight follow / accent draw / sparkle
   ═══════════════════════════════════════════════ */

/* Spotlight follow — sets --mx / --my on hovered .cs-card / .cl-card */
document.addEventListener('pointermove', function(e) {
  var card = e.target.closest('.cs-card, .cl-card');
  if (!card) return;
  var rect = card.getBoundingClientRect();
  var x = e.clientX - rect.left;
  var y = e.clientY - rect.top;
  card.style.setProperty('--mx', x + 'px');
  card.style.setProperty('--my', y + 'px');
});

/* Stroke-draw observer for accent bars on scroll-into-view */
(function() {
  if (!('IntersectionObserver' in window)) return;
  var accentObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('accent-revealed');
        accentObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.complete-look, .complete-set, .accordion').forEach(function(el) {
    accentObs.observe(el);
  });
})();

/* Gold sparkle burst — fires on Add-to-Bag click */
function spawnSparkles(originEl) {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var rect = originEl.getBoundingClientRect();
  var cx = rect.left + rect.width  / 2;
  var cy = rect.top  + rect.height / 2;
  var count = 14;
  for (var i = 0; i < count; i++) {
    var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4;
    var dist  = 55 + Math.random() * 55;
    var dx    = Math.cos(angle) * dist;
    var dy    = Math.sin(angle) * dist;
    var size  = 4 + Math.random() * 4;
    var p = document.createElement('span');
    p.className = 'sparkle';
    p.style.left = cx + 'px';
    p.style.top  = cy + 'px';
    p.style.width  = size + 'px';
    p.style.height = size + 'px';
    p.style.setProperty('--dx', dx + 'px');
    p.style.setProperty('--dy', dy + 'px');
    document.body.appendChild(p);
    setTimeout((function(el) { return function() { el.remove(); }; })(p), 900);
  }
}
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.btn-atb');
  if (!btn || btn.disabled) return;
  spawnSparkles(btn);
});

/* ═══════════════════════════════════════════════
   CARD THUMBNAIL HOVER
   ═══════════════════════════════════════════════ */
(function() {
  /* Touch devices: iOS Safari treats a tap as "hover" first — and if a mouseover
     handler mutates the DOM (like these image swaps), it consumes the tap and the
     CLICK NEVER FIRES, so product links felt dead on mobile. All mouseover-phase
     work is desktop-only; touch keeps its own touchstart tap-to-peek handler. */
  var CAN_HOVER = !(window.matchMedia && window.matchMedia('(hover: none)').matches);

  /* Hover images are deferred (data-src) so they don't load on grid scroll.
     origSrc points at the deferred URL so thumb-swap resets still resolve. */
  document.querySelectorAll('.product-card__img--hover').forEach(function(img) {
    img.dataset.origSrc = img.dataset.src || img.src;
  });

  /* Load a card's deferred hover image once (first hover / tap / thumb interaction) */
  function loadHover(card) {
    if (!card) return;
    var img = card.querySelector('.product-card__img--hover');
    if (img && img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
  }

  /* First pointer over any card → load its hover image (desktop only) */
  document.addEventListener('mouseover', function(e) {
    if (!CAN_HOVER) return;
    var card = e.target.closest ? e.target.closest('.product-card') : null;
    if (card) loadHover(card);
  }, { passive: true });

  /* Thumb enter — show that thumb's image in the hover overlay */
  document.addEventListener('mouseover', function(e) {
    if (!CAN_HOVER) return;
    var item = e.target.closest('.product-card__thumb-item');
    if (!item) return;
    var card = item.closest('.product-card');
    if (!card) return;
    var hoverImg = card.querySelector('.product-card__img--hover');
    var fullSrc = item.dataset.full;
    if (hoverImg && fullSrc) hoverImg.src = fullSrc;
    card.querySelectorAll('.product-card__thumb-item').forEach(function(d) { d.classList.remove('active'); });
    item.classList.add('active');
  });

  /* Thumb leave — reset overlay to original image[1] if not going to another thumb */
  document.addEventListener('mouseout', function(e) {
    if (!CAN_HOVER) return;
    var item = e.target.closest('.product-card__thumb-item');
    if (!item) return;
    if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.product-card__thumb-item')) return;
    var card = item.closest('.product-card');
    if (!card) return;
    var hoverImg = card.querySelector('.product-card__img--hover');
    if (hoverImg && hoverImg.dataset.origSrc) hoverImg.src = hoverImg.dataset.origSrc;
    var thumbs = card.querySelectorAll('.product-card__thumb-item');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    if (thumbs[0]) thumbs[0].classList.add('active');
  });

  /* Card leave — reset overlay and active thumb */
  document.addEventListener('mouseleave', function(e) {
    if (!CAN_HOVER) return;
    var card = e.target.closest ? e.target.closest('.product-card') : null;
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    var hoverImg = card.querySelector('.product-card__img--hover');
    if (hoverImg && hoverImg.dataset.origSrc) hoverImg.src = hoverImg.dataset.origSrc;
    var thumbs = card.querySelectorAll('.product-card__thumb-item');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    if (thumbs[0]) thumbs[0].classList.add('active');
  }, true);

  /* Mobile: tap to show second image */
  document.addEventListener('touchstart', function(e) {
    var link = e.target.closest('.product-card__img-link');
    if (!link) return;
    var wrap = link.closest('.product-card__img-wrap');
    if (!wrap || !wrap.querySelector('.product-card__img--hover')) return;
    loadHover(wrap.closest('.product-card'));
    wrap.classList.add('show-alt');
    setTimeout(function() { wrap.classList.remove('show-alt'); }, 1200);
  }, { passive: true });

  /* Pressing ANYWHERE on a product card — the picture especially — enters the
     product. The card is a stack of layers (image link, stretched info-link
     overlay, badges with pointer-events:none, hover thumb strip), and a tap can
     land on a layer that isn't a link; this delegated fallback catches every such
     dead zone. Quick View + thumbnail taps are excluded so they still do their
     own thing, and taps already on a real link navigate natively. */
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.product-card');
    if (!card) return;
    if (e.target.closest('.product-card__quick, .js-quick-view, .product-card__thumb-item, .product-card__thumb-row')) return;
    if (e.target.closest('a[href]')) return;   /* native link click — let it through */
    var link = card.querySelector('.product-card__img-link[href], .product-card__info-link[href]');
    var href = link && link.getAttribute('href');
    if (href) { e.preventDefault(); window.location.href = href; }
  });
})();

/* ═══════════════════════════════════════════════
   SCROLL ANIMATION OBSERVER
   ═══════════════════════════════════════════════ */
var animObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      var el    = entry.target;
      var delay = parseFloat(el.dataset.delay || 0) * 60;
      if (delay) {
        setTimeout(function() { el.classList.add('revealed'); }, delay);
      } else {
        el.classList.add('revealed');
      }
      animObserver.unobserve(el);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

// In the Shopify Customize editor, sections re-render on edit but the observer
// never sees the freshly-injected nodes, so [data-animate] elements stay stuck
// at opacity:0 and your edit looks like it vanished. Reveal instantly there.
var jzDesignMode = !!(window.Shopify && window.Shopify.designMode);

function jzBindAnimate(scope) {
  (scope || document).querySelectorAll('[data-animate]').forEach(function(el) {
    if (el.classList.contains('revealed')) return;
    if (jzDesignMode) { el.classList.add('revealed'); }
    else { animObserver.observe(el); }
  });
}

jzBindAnimate(document);

// Re-reveal a section's content whenever it's loaded/edited/selected in Customize.
if (jzDesignMode) {
  document.addEventListener('shopify:section:load',   function(e) { jzBindAnimate(e.target); });
  document.addEventListener('shopify:section:select', function(e) { jzBindAnimate(e.target); });
  document.addEventListener('shopify:block:select',   function(e) { jzBindAnimate(e.target); });
}

/* ═══ Skeleton loading — EVERY image, site-wide ═══
   Two layers:
   1. Product cards keep the nicer wrapper treatment (image fades in over the shimmer).
   2. Every other <img> gets a shimmer painted directly behind it until it loads.
   A MutationObserver re-runs this for any image injected later (search, cart drawer,
   quick view, related, dropdown thumbs, etc.) so it truly covers everything. */

/* Tag landscape (non-square) product photos so CSS nudges ONLY those down/smaller
   in the square tile. Near-square photos (ratio ≤ 1.12) are left untouched. */
function tagCardAspect(img) {
  if (!img) return;
  var apply = function() {
    if (!img.naturalWidth || !img.naturalHeight) return;
    if (img.naturalWidth / img.naturalHeight > 1.12) img.classList.add('is-wide');
    else img.classList.remove('is-wide');
  };
  if (img.complete && img.naturalWidth > 0) apply();
  else img.addEventListener('load', apply, { once: true });
}
window.tagCardAspect = tagCardAspect;

/* Product-card wrappers (image fades in over a shimmer ::after) */
function initImgSkeletons(scope) {
  (scope || document).querySelectorAll('.product-card__img-wrap').forEach(function(wrap) {
    wrap.querySelectorAll('.product-card__img').forEach(tagCardAspect); /* main + hover */
    if (wrap.dataset.skelInit) return;
    var img = wrap.querySelector('.product-card__img');
    if (!img) return;
    wrap.dataset.skelInit = '1';
    if (img.complete && img.naturalWidth > 0) return; /* already loaded / cached */
    wrap.classList.add('is-loading');
    var done = function() { wrap.classList.remove('is-loading'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });
}
window.initImgSkeletons = initImgSkeletons;

/* Every individual <img> on the page (shimmer behind it until loaded) */
function skeletonizeImg(img) {
  if (img.dataset.skel) return;                      /* already handled */
  if (img.hasAttribute('data-no-skeleton')) return;  /* explicit opt-out */
  if (img.closest('.product-card__img-wrap')) return;/* handled by wrapper layer above */
  img.dataset.skel = '1';
  if (img.complete && img.naturalWidth > 0) return;  /* already loaded / cached → no flash */
  img.classList.add('img-skel');
  var done = function() { img.classList.remove('img-skel'); };
  img.addEventListener('load', done, { once: true });
  img.addEventListener('error', done, { once: true });
}
function initAllImgSkeletons(scope) {
  initImgSkeletons(scope);
  (scope || document).querySelectorAll('img').forEach(skeletonizeImg);
}
window.initAllImgSkeletons = initAllImgSkeletons;

initAllImgSkeletons();

/* Catch images added to the DOM after first paint */
if (window.MutationObserver) {
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'IMG') { skeletonizeImg(node); return; }
        if (node.querySelectorAll) {
          if (node.classList && node.classList.contains('product-card__img-wrap')) initImgSkeletons(node.parentNode || document);
          else if (node.querySelector('.product-card__img-wrap')) initImgSkeletons(node);
          node.querySelectorAll('img').forEach(skeletonizeImg);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

/* ═══════════════════════════════════════════════════════════════
   PRODUCT PAGE — PREMIUM POLISH (additions, not overrides)
   ═══════════════════════════════════════════════════════════════ */
(function ppPolish(){
  var mainBtn = document.getElementById('btnAtb');
  if (!mainBtn) return;

  /* — Sticky mobile add-to-bag bar visibility — */
  var sticky = document.getElementById('stickyAtb');
  if (sticky) {
    /* Desktop: bar appears only once the buy button has been scrolled PAST.
       Mobile: ALSO while the button is still ahead below the fold (after a
       small scroll so it never covers the gallery on load) — the buy CTA on
       mobile sits under personalization/cross-sell, so without this there is
       no reachable Add to Bag for most of the page. */
    var _stickyShown = null;
    var updateSticky = function(){
      var r = mainBtn.getBoundingClientRect();
      var pastBtn  = r.bottom < 80;                   /* scrolled past the CTA */
      var aheadBtn = r.top > window.innerHeight;      /* CTA still below the fold */
      var isMobile = window.matchMedia('(max-width: 800px)').matches;
      var show = pastBtn || (isMobile && aheadBtn && window.scrollY > 160);
      if (show === _stickyShown) return;
      _stickyShown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    var _stickyTick = false;
    window.addEventListener('scroll', function(){
      if (_stickyTick) return;
      _stickyTick = true;
      requestAnimationFrame(function(){ _stickyTick = false; updateSticky(); });
    }, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();

    var stickyBtn = document.getElementById('stickyAtbBtn');
    var stickyTxt = document.getElementById('stickyAtbText');
    var stickyPrice = document.getElementById('stickyAtbPrice');
    var btnText = document.getElementById('btnAtbText');
    if (stickyBtn && stickyTxt && btnText) {
      var syncSticky = function(){
        stickyTxt.textContent = btnText.textContent;
        stickyBtn.disabled = mainBtn.disabled;
      };
      var mo = new MutationObserver(syncSticky);
      mo.observe(btnText, { childList: true, characterData: true, subtree: true });
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    if (stickyPrice) {
      var infoPrice = document.getElementById('infoPrice');
      if (infoPrice) {
        var pmo = new MutationObserver(function(){ stickyPrice.textContent = infoPrice.textContent; });
        pmo.observe(infoPrice, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  /* — Magnetic hover on the main ATB (desktop only) — */
  if (window.matchMedia && !window.matchMedia('(hover: none)').matches) {
    var rect = null;
    mainBtn.addEventListener('mouseenter', function(){ rect = mainBtn.getBoundingClientRect(); });
    mainBtn.addEventListener('mousemove', function(e){
      if (!rect) rect = mainBtn.getBoundingClientRect();
      var x = (e.clientX - rect.left - rect.width / 2) * 0.18;
      var y = (e.clientY - rect.top - rect.height / 2) * 0.18;
      mainBtn.style.transform = 'translate(' + x + 'px,' + (y - 2) + 'px)';
    });
    mainBtn.addEventListener('mouseleave', function(){
      mainBtn.style.transform = '';
      rect = null;
    });
  }

  /* — Particle burst on successful add-to-cart — */
  function burst(target){
    var b = document.createElement('span');
    b.className = 'btn-atb-burst';
    var n = 14;
    for (var i = 0; i < n; i++){
      var p = document.createElement('i');
      var angle = (Math.PI * 2 * i) / n + Math.random() * 0.4;
      var dist = 70 + Math.random() * 40;
      p.style.setProperty('--tx', Math.cos(angle) * dist + 'px');
      p.style.setProperty('--ty', Math.sin(angle) * dist + 'px');
      p.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      p.style.animationDelay = (Math.random() * 0.06) + 's';
      b.appendChild(p);
    }
    target.appendChild(b);
    setTimeout(function(){ if (b.parentNode) b.parentNode.removeChild(b); }, 1000);
  }
  var burstObs = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.attributeName === 'class' && mainBtn.classList.contains('added')) {
        burst(mainBtn);
      }
    });
  });
  burstObs.observe(mainBtn, { attributes: true });

  /* — Ripple on size button tap — */
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.size-btn');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'pp-ripple';
    var size = Math.max(r.width, r.height);
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - r.left - size / 2) + 'px';
    ripple.style.top  = (e.clientY - r.top  - size / 2) + 'px';
    btn.appendChild(ripple);
    setTimeout(function(){ if (ripple.parentNode) ripple.parentNode.removeChild(ripple); }, 600);
  });

  /* — Personalization "has-text" state — */
  var customInput = document.getElementById('customText');
  var customWrap = document.getElementById('productCustom');
  if (customInput && customWrap) {
    var setHasText = function(){ customWrap.classList.toggle('has-text', !!customInput.value.trim()); };
    customInput.addEventListener('input', setHasText);
    customInput.addEventListener('change', setHasText);
    setHasText();
  }
})();

/* ═══════════════════════════════════════════════════════════════
   PRODUCT PAGE — A: GALLERY HOVER-ZOOM (desktop only)
   ═══════════════════════════════════════════════════════════════ */
(function ppGalleryZoom(){
  var main = document.getElementById('galleryMain');
  var img = document.getElementById('mainImg');
  var lens = document.getElementById('galleryZoomLens');
  if (!main || !img || !lens) return;
  if (window.matchMedia && window.matchMedia('(hover: none), (max-width: 900px)').matches) return;

  var hover = false;

  function updateLens(e){
    var r = main.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));
    lens.style.backgroundPosition = x + '% ' + y + '%';
  }

  function syncSrc(){
    // Use 1600w version for sharper zoom; fall back to current src
    var hi = img.getAttribute('data-zoom-src') || img.src;
    if (img.srcset) {
      // Try to pick a 1440w from srcset
      var m = img.srcset.match(/([^\s,]+)\s+1440w/);
      if (m && m[1]) hi = m[1];
    }
    lens.style.setProperty('--zoom-src', 'url("' + hi + '")');
  }

  main.addEventListener('mouseenter', function(){
    hover = true;
    syncSrc();
    main.classList.add('zoom-active');
  });
  main.addEventListener('mouseleave', function(){
    hover = false;
    main.classList.remove('zoom-active');
  });
  main.addEventListener('mousemove', function(e){ if (hover) updateLens(e); });

  // Re-sync zoom source when main image changes (variant swap, thumb click)
  var imgObs = new MutationObserver(function(){ if (hover) syncSrc(); });
  imgObs.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
})();

/* ═══════════════════════════════════════════════
   HEADER — scroll reveal + desktop hover-intent dropdowns
   ═══════════════════════════════════════════════ */
(function() {
  function initHeader() {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var body = document.body;

    /* ─────────── Scroll reveal ───────────
       Conventional pattern: scrolling DOWN hides the header (more room for
       content); scrolling UP reveals it instantly. Always shown near the top. */
    var SHOW_ON_DOWN = false;
    var TOP_LOCK     = 64;   // within this many px of the top, always show
    var DELTA        = 7;    // ignore scroll jitter smaller than this

    var lastY   = window.pageYOffset || 0;
    var ticking = false;

    /* Don't hide the header while a dropdown or any drawer is open */
    function overlayOpen() {
      if (nav.querySelector('.nav__item.is-open')) return true;
      var ids = ['mobileNav', 'searchOverlay', 'cartDrawer'];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el && el.classList.contains('open')) return true;
      }
      return false;
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      body.classList.toggle('nav-scrolled', y > 8);

      if (y <= TOP_LOCK || overlayOpen()) {
        body.classList.remove('nav-hidden');
        lastY = y;
        return;
      }

      var diff = y - lastY;
      if (Math.abs(diff) < DELTA) return;   // keep lastY so small moves accumulate

      var down      = diff > 0;
      var shouldShow = SHOW_ON_DOWN ? down : !down;
      body.classList.toggle('nav-hidden', !shouldShow);
      lastY = y;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();

    /* ─────────── Desktop hover-intent dropdowns ───────────
       Open on enter, stay open while the pointer is over the link OR the
       panel, close ~220ms after leaving (cancelled if the pointer returns). */
    var fine = !(window.matchMedia && window.matchMedia('(hover: none), (max-width: 800px)').matches);
    if (fine) {
      var CLOSE_DELAY = 220;
      var items = [].slice.call(nav.querySelectorAll('.nav__item.has-dropdown'));

      items.forEach(function(item) {
        var timer = null;
        function open() {
          if (timer) { clearTimeout(timer); timer = null; }
          items.forEach(function(o) { if (o !== item) o.classList.remove('is-open'); });
          item.classList.add('is-open');
        }
        function scheduleClose() {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function() { item.classList.remove('is-open'); timer = null; }, CLOSE_DELAY);
        }
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', scheduleClose);
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', function(e) {
          if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
        });
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          items.forEach(function(i) { i.classList.remove('is-open'); });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

/* ═══════════════════════════════════════════════
   COLLECTION "TEAMS" SIDEBAR — load the full club list off the critical path.
   The page renders the popular clubs instantly (cheap Pass-1). Here we fetch the
   complete list from the lightweight ?view=teams endpoint (edge-cached) and swap
   it in, so collection pages stay fast while keeping every club chip.
   ═══════════════════════════════════════════════ */
(function () {
  var ul = document.querySelector('.coll-teams[data-teams-src]');
  if (!ul) return;
  var src = ul.getAttribute('data-teams-src');
  ul.removeAttribute('data-teams-src');
  var go = function () {
    fetch(src, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        html = html.trim();
        /* Only inject if it looks like our chip list — never a full page / error */
        if (html.indexOf('coll-coll-card--team') === -1) return;
        if (/^<!doctype|^<html/i.test(html)) return;
        ul.innerHTML = html;
      })
      .catch(function () {});
  };
  if ('requestIdleCallback' in window) { requestIdleCallback(go, { timeout: 2000 }); }
  else { setTimeout(go, 300); }
})();

/* ═══════════════════════════════════════════════
   INSTANT NAVIGATION
   1) Top progress bar  → instant "it registered" feedback on every tap
   2) Prefetch on intent → the next page loads before the tap finishes,
      so the redirect feels near-instant.
   ═══════════════════════════════════════════════ */
(function () {
  var origin = location.origin;

  /* Browsers WITHOUT the View Transitions API (Firefox, older Safari, some
     in-app browsers) don't get the CSS page fade — so give them a quick
     "dim-out" on the leaving page instead, so the fade cue is on ALL platforms.
     Chromium/Safari 18.2+ use the richer View Transition and skip this. */
  var noVT = !document.startViewTransition;
  var okMotion = true;
  try { okMotion = !matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function dimOut() {
    if (!(noVT && okMotion)) return;
    var r = document.documentElement;
    r.style.transition = 'opacity .32s ease-in-out';
    r.style.opacity = '0.4';               /* dim, not blank — never jarring on slow loads */
  }
  /* Restore opacity if the dimmed page comes back via bfcache (back button). */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { var r = document.documentElement; r.style.transition = ''; r.style.opacity = ''; }
  });

  /* ---------- 1. Top loading bar ---------- */
  var bar, trickle, failsafe, width;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'jz-prog';
    (document.body || document.documentElement).appendChild(bar);
    return bar;
  }
  function startBar() {
    ensureBar();
    if (bar.classList.contains('is-active')) return; /* already running — don't restart/flicker */
    width = 6;
    bar.style.transition = 'none';
    bar.style.width = '0%';
    bar.classList.add('is-active');
    void bar.offsetWidth; /* commit the 0% before animating */
    bar.style.transition = 'width .25s cubic-bezier(.2,.7,.3,1), opacity .3s ease';
    bar.style.width = width + '%';
    clearInterval(trickle);
    trickle = setInterval(function () {
      width += (92 - width) * 0.13;       /* ease toward 92%, never reaching it */
      bar.style.width = width.toFixed(1) + '%';
    }, 220);
    clearTimeout(failsafe);
    failsafe = setTimeout(doneBar, 10000); /* never trickle forever */
  }
  function doneBar() {
    clearInterval(trickle);
    clearTimeout(failsafe);
    if (!bar) return;
    bar.style.width = '100%';
    setTimeout(function () { bar.classList.remove('is-active'); }, 200);
    setTimeout(function () { if (bar) { bar.style.transition = 'none'; bar.style.width = '0%'; } }, 560);
  }

  /* ---------- 2. Which links are internal navigations we can speed up ---------- */
  function navTarget(a) {
    if (!a || !a.href) return null;
    if (a.target && a.target !== '' && a.target !== '_self') return null;
    if (a.hasAttribute('download') || a.hasAttribute('data-no-prefetch')) return null;
    if ((a.getAttribute('rel') || '').indexOf('external') !== -1) return null;
    var raw = a.getAttribute('href') || '';
    if (!raw || raw[0] === '#' || /^(mailto:|tel:|javascript:|wa\.me|https?:\/\/wa\.me)/i.test(raw)) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== origin) return null;                                   /* same store only */
    if (u.pathname === location.pathname && u.search === location.search) return null; /* same page */
    if (/\/(cart|checkout|account)(\/|$|\?)/.test(u.pathname)) return null;  /* never prefetch cart/checkout/account */
    if (/\.(js|json|atom|xml|pdf)(\?|$)/.test(u.pathname)) return null;
    if (/\/(logout|customer_authentication|orders)/.test(u.pathname)) return null;
    return u.href;
  }

  /* ---------- Start the bar the instant a real navigation begins ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && navTarget(a)) { startBar(); dimOut(); }
  }, false);

  /* MOBILE: show the bar the instant a tap on an internal link is confirmed —
     on pointerup, a few ms before 'click', so the gold bar is visible even when
     the next page (often prerendered) opens almost instantly. We require the
     finger NOT to have moved (>10px = a scroll-drag, not a tap) so it never
     flashes while the user is just scrolling over a product card. */
  var _tap = null;
  document.addEventListener('pointerdown', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    _tap = (a && navTarget(a)) ? { x: e.clientX, y: e.clientY } : null;
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (_tap && (Math.abs(e.clientX - _tap.x) > 10 || Math.abs(e.clientY - _tap.y) > 10)) _tap = null;
  }, { passive: true });
  document.addEventListener('pointerup', function () {
    if (_tap) { startBar(); _tap = null; }
  }, { passive: true });
  document.addEventListener('pointercancel', function () { _tap = null; }, { passive: true });
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var f = e.target;
    if (!f || f.target === '_blank') return;
    if (f.matches('[data-no-prefetch], form[action*="/cart"]')) return; /* ajax cart forms handle their own UI */
    startBar();
  }, false);
  window.addEventListener('pagehide', doneBar);
  window.addEventListener('pageshow', function (e) { if (e.persisted) doneBar(); }); /* bfcache back button */

  /* ---------- 3. Prefetch the next page on hover / first touch ----------
     Chromium gets the richer Speculation Rules (injected in theme.liquid);
     here we only run the <link rel=prefetch> fallback where that's unsupported
     (Safari/Firefox), so we never double-fetch. Skipped on data-saver / 2G. ---- */
  var hasSpecRules = (typeof HTMLScriptElement !== 'undefined') &&
                     HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
  var conn = navigator.connection || {};
  var lowData = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  if (!hasSpecRules && !lowData) {
    var seen = {}, count = 0, MAX = 12, hoverTimer;
    function prefetch(url) {
      if (!url || seen[url] || count >= MAX) return;
      seen[url] = 1; count++;
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.as = 'document'; l.href = url;
      document.head.appendChild(l);
    }
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var url = navTarget(a);
      if (!url) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { prefetch(url); }, 60); /* require ~60ms of intent */
    }, { passive: true });
    document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true });
    document.addEventListener('touchstart', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a) prefetch(navTarget(a)); /* a touch is strong intent — prefetch right away */
    }, { passive: true });
  }
})();

